import React from "react"
import KlaroConsentInfo from "../../../../components/modules/KlaroConsentInfo"
import useKlaroConsentable from "../../../../hooks/useKlaroConsentable"

const KLARO_YOUTUBE_APP_KEY = "functional_widgets"
const KLARO_VIMEO_APP_KEY = "functional_widgets"

const Video = ({ video_url, ratio, _uid, className }) => {
  let video
  let video_code
  let video_plattform
  let consentKey

  if (video_url.includes("vimeo.com")) {
    consentKey = KLARO_VIMEO_APP_KEY
    video_plattform = "https://player.vimeo.com/video/"
    video = video_url.split("vimeo.com/")
    video_code = video[1]
  }
  if (video_url.includes("watch?")) {
    consentKey = KLARO_YOUTUBE_APP_KEY
    video_plattform = "https://www.youtube-nocookie.com/embed/"
    video = video_url.split("?v=")
    video_code = video[1]
  }
  if (video_url.includes("/embed/")) {
    consentKey = KLARO_YOUTUBE_APP_KEY
    video_plattform = "https://www.youtube-nocookie.com/embed/"
    video = video_url.split("/embed/")
    video_code = video[1]
  }
  if (video_url.includes(".be/")) {
    consentKey = KLARO_YOUTUBE_APP_KEY
    video_plattform = "https://www.youtube-nocookie.com/embed/"
    video = video_url.split(".be/")
    video_code = video[1]
  }
  const { usageConsented, appInfo, handleKlaroConsent } =
    useKlaroConsentable(consentKey)

  let appName = "Youtube"

  return (
    <div className={`embed embed-${ratio} ${className ? className : ""}`}>
      {usageConsented !== null &&
        (usageConsented === false && appInfo ? (
          <KlaroConsentInfo
            appInfo={appInfo}
            appName={appName}
            handleKlaroConsent={handleKlaroConsent}
            renderWrapper={false}
            textPositionClassName="text-left"
          />
        ) : (
          <iframe
            className="bg-ro-black embed-item txa"
            title={"iframe-" + _uid}
            width="1920"
            height="1080"
            src={video_plattform + video_code}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        ))}
    </div>
  )
}

export default Video
